const storageKey = 'rhm-panel-session';

export function readSession() {
  try {
    const raw = localStorage.getItem(storageKey);
    if (!raw) return null;
    const stored = JSON.parse(raw);
    if (!stored || !stored.accessToken || !stored.refreshToken) return null;
    return stored;
  } catch {
    return null;
  }
}

export function writeSession(session) {
  localStorage.setItem(storageKey, JSON.stringify(session));
}

export function clearSession() {
  localStorage.removeItem(storageKey);
}
